import { OKSign } from '@/domains/CommonDomain'

export const TransactionRequestRowCount = 50

export interface IFindTransferLimitResponse {
  trxLimit: string // 1회 당행 이체한도
  trxLimitOther: string // 1회 타행 이체한도
  dayLimit: string // 1일 당행 이체한도
  dayLimitOther: string // 1일 타행 이체한도
  trxLimitRanges: string[] // 1회 당행 이체한도 구간범위 목록
  trxLimitOtherRanges: string[] // 1회 타행 이체한도
  dayLimitRanges: string[] // 1일 당행 이체한도
  dayLimitOtherRanges: string[] // 1일 타행 이체한도
  minTrxLimit: string // 1회 당행 이체한도 최소값
  minTrxLimitOther: string // 1회 타행 이체한도 최소값
  minDayLimit: string // 1일 당행 이체한도 최소값
  minDayLimitOther: string // 1일 타행 이체한도 최소값
  maxTrxLimit: string // 1회 당행 이체한도 최대값
  maxTrxLimitOther: string // 1회 타행 이체한도 최대값
  maxDayLimit: string // 1일 당행 이체한도 최대값
  maxDayLimitOther: string // 1일 타행 이체한도 최대값
}

export const EmptyFindTransferLimitResponse: IFindTransferLimitResponse = {
  dayLimit: '',
  dayLimitOther: '',
  maxDayLimit: '',
  maxDayLimitOther: '',
  maxTrxLimit: '',
  maxTrxLimitOther: '',
  minDayLimit: '',
  minDayLimitOther: '',
  minTrxLimit: '',
  minTrxLimitOther: '',
  trxLimit: '',
  trxLimitOther: '',
  trxLimitRanges: [],
  trxLimitOtherRanges: [],
  dayLimitRanges: [],
  dayLimitOtherRanges: [],
}

export interface IFindAccountOwnerResponse {
  crBnkCd: string // 수취은행코드
  crAcctNo: number // 수취계좌번호
  crAcctNm1: string // 수취계좌주이름1
  crAcctNm2: string // 수취계좌주이름2
  feeAmt: string // 이체수수료
}

export interface IAddFavoriteTransfer {
  trnsAcctKey: number // 최근이체 Key
}

export interface IRemoveFavoriteTransfer {
  trnsAcctKey: number // 최근이체 Key
}

export interface IInquiryFinancialInstitutionResponse {
  list: IFinancialInstitution[]
}

export interface IInquiryRecentBookmarkTransferResponse {
  recents: ITransferTransaction[] // 최근이체목록
  bookmarks: ITransferTransaction[] // 즐겨찾기목록
}

export interface IFinancialInstitution {
  bankCd: string // 은행코드
  bankNm: string // 은행명
  biBankCd: string // BI은행코드 (용도 확인중)
}

export interface ITransferTransaction {
  trscType: TransactionType
  trnsAcctKey: number // 최근이체계좌key
  extUsrId: string // 외부 수취인 식별자 (라인사용자식별자 or 휴대폰번호)
  extUsrNm: string // 라인사용자별칭
  thumbUrl: string // 썸네일이미지URL
  crBnkCd: string // 은행코드번호
  crBnkBicCd?: string // bank code BI
  crBnkNm: string // 은행이름
  crAcctNo: string // 계좌번호
  crAcctNm1: string // 예금주명1
  crAcctNm2: string // 예금주명2
  crAcctAlias: string // 계좌별칭
  crAcctColor: number // 계좌색상
  favYn: OKSign // 즐겨찾기여부
  crAcctItmCd?: string // Account number item (BI-Fast)
  crAcctKindDvCd?: CreditAccountKindCode // Account kind Code (BI-Fast)
}

export enum CreditAccountKindCode {
  BI_FAST_ACCOUNT_NO = '00',
  BI_FAST_MOBILE_NO = '01',
  BI_FAST_EMAIL = '02',
}

export enum TransactionType {
  MY_ACCOUNT = '11', // 계좌번호(내계좌)
  EQUALITY_CAPITAL = '12', //계좌번호(당행간)
  OTHER_BANK = '13', // 계좌번호(타행)
  BI_FAST_ACCOUNT_NO = '14', // BI-Fast 계좌번호
  LINE = '20', // 라인ID(뱅크비회원)
  LINE_AND_EQUALITY_CAPITAL = '21', // 라인ID(당행간)
  PHONE_NUMBER = '30', // 휴대폰번호(뱅크비회원)
  PHONE_NUMBER_EQUALITY_CAPITAL = '31', // 휴대폰번호(당행간)
  // BI_FAST_MOBILE_NO = '42', // BI-Fast 전화번호(hybrid에서는 취급x)
  // BI_FAST_EMAIL = '43', // BI-Fast 이메일주소(hybrid에서는 취급x)
}

export interface IChangeTransactionNoteRequest {
  refNo: string
  trxNote: string
}

export interface IFindRecentlyFavoriteTransferRequest {
  trscDvCd: TransactionDivisionCode
  trscType: TransactionRequestType
  rowCnt: number
  wdrwAcctNo: string // 출금 계좌번호
}

export interface IValidateRecentlyFavoriteTransferRequest {
  trnsAcctKey: number // 최근이체계좌key
  crBnkCd: string // 은행코드번호
  crAcctNo: string // 계좌번호
}

export interface IValidateRecentlyFavoriteTransferBIFastRequest {
  crAcctKindDvCd: CreditAccountKindCode // BI-Fast credit account kind code
  trnsAcctKey: number // recently transfer key
  crBnkBicCd?: string // receiver bank code - BI-Fast
  crAcctItmCd?: string // BI-Fast credit account number item
}

export enum TransactionDivisionCode {
  FAVORITE_RECENT,
  FAVORITE,
  RECENT,
}

export enum TransactionRequestType {
  ALL,
  ACCOUNT_NUMBER_ONLY,
}

export const getAccountColorClass = (crAcctColor: number) => {
  switch (crAcctColor) {
    case 0:
      return 'is-green'
    case 1:
      return 'is-bluegreen'
    case 2:
      return 'is-skyblue'
    case 3:
      return 'is-deepblue'
    case 4:
      return 'is-purple'
    case 5:
      return 'is-pink'
    case 6:
      return 'is-coral'
    case 7:
      return 'is-orange'
    case 8:
      return 'is-carrot'
    case 9:
      return 'is-yellow'
    case 10:
      return 'is-camel'
    case 11:
      return 'is-brown'
    case 12:
      return 'is-warmgray'
    case 13:
      return 'is-darkgray'
    default:
      return ''
  }
}

export enum TransferTypeCode {
  ALL,
  ONLINE,
  BI_FAST = 10,
}

export interface IFindTransferLimitByTypeRequest {
  transferTypeCode: TransferTypeCode
}

export interface IFindTransferLimitByTypeDetail extends IFindTransferLimitResponse {
  transferTypeCode: TransferTypeCode // Transfer Type Code(1: online transfer, 10: BI-Fast)
}
export interface IFindTransferLimitByTypeResponse {
  onlineLimits: IFindTransferLimitByTypeDetail
  biFastLimits: IFindTransferLimitByTypeDetail
}

export interface IFindAccountOwnerBIFastRequest {
  crBnkCd?: string // receiver bank code
  crBnkBicCd?: string // receiver bank code (BI-Fast)
  crAcctNo?: string // receiver account no
  crAcctItmCd?: string // BI-Fast credit account number item
  crAcctKindDvCd?: CreditAccountKindCode // BI-Fast credit account kind code (null, 00, 01, 02)
}

export interface IFindAccountOwnerBIFastDetail {
  crAcctItmCd?: string // receiver bank code
  crAcctKindDvCd?: CreditAccountKindCode // BI-Fast credit account kind
  crBnkCd: string // receiver bank code
  crBnkNm?: string // receiver bank name, bi fast only
  reserved: string // receiver bank code
  crAcctNo: string // receiver account code
  crAcctNm1: string // receiver account owner name1
  crAcctNm2: string // receiver account owner name2
  feeAmt: string
}

export interface IFindAccountOwnerBIFastResponse {
  biAccount?: IFindAccountOwnerBIFastDetail
  onlineAccount?: IFindAccountOwnerBIFastDetail
  restQuota: number
  totQuota: number
}
